<template>
  <span v-if="readonly" class="text-gray-400">
    {{ modelValue?.name }}
  </span>
  <action-menu v-else class="text-gray-400">
    <template #trigger>
      <div class="flex items-center space-x-2">
        <span v-if="!modelValue">Choose Scorecard</span>
        <span v-else>{{ modelValue.name }}</span>
        <icon-base
          height="6"
          width="10"
          :icon="IconDropdownArrow"
          :icon-color="UTIL_COLORS.DEFAULT"
        />
      </div>
    </template>
    <action-menu-item
      v-for="sc in scorecards"
      :key="sc.id"
      @click="handleOptionClick(sc)"
    >
      {{ sc.name }}
    </action-menu-item>
  </action-menu>
</template>

<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";

import IconDropdownArrow from "@/components/icons/IconDropdownArrow.vue";
import ActionMenuItem from "@/components/ui/ActionMenuItem.vue";
import ActionMenu from "@/components/ui/ActionMenuV2.vue";

import type { IScorecard } from "@/models/scorecards";

interface Props {
  scorecards: IScorecard[];
  modelValue: IScorecard | null;
  readonly?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  (eventName: "update:modelValue", value: IScorecard): void;
}>();

const handleOptionClick = (scorecard: IScorecard) => {
  emit("update:modelValue", scorecard);
};
</script>
